import { render } from "./PetProjectOneDialog.vue?vue&type=template&id=204c4b74"
import script from "./PetProjectOneDialog.vue?vue&type=script&lang=js"
export * from "./PetProjectOneDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__